import { createAction } from "../fns/createAction";
import { fns, libTypes } from "@holta/lib";
import { ProductComponent } from "@holta/lib/types";
import { feathersApp } from "../config/feathers";

export const setProductComponents = createAction("SET_PRODUCT_PRODUCT_COMPONENTS", (newState, productComponents: ProductComponent[]) => {
    newState.productComponents = productComponents;
});

